import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { setUser } from "../store/reducers/authReducer";
import { useUserMeQuery } from "../store/services/authService";

const UserRoute = () => {
  const dispatch = useDispatch();
  const { userToken, user } = useSelector(
    (state) => state.authReducer
  );

  const {
    data,
    isLoading,
    isFetching,
  } = useUserMeQuery(
    user?.id || "current-session",
    {
      skip: !userToken,
      refetchOnMountOrArgChange: true,
    }
  );

  useEffect(() => {
    if (data?.user) {
      dispatch(setUser(data.user));
    }
  }, [data?.user, dispatch]);

  if (!userToken) {
    return <Navigate to="/login" replace />;
  }

  if ((isLoading || isFetching) && !data?.user) {
    return null;
  }

  return <Outlet />;
};

export default UserRoute;
